import React from 'react';
import { Row, Col, Typography, Card } from 'antd';
import {
    ArrowRightOutlined,
    FieldTimeOutlined,
    DeploymentUnitOutlined,
    UserSwitchOutlined,
} from '@ant-design/icons';
import * as Config from '../../../Config';

const { Title, Text } = Typography;

const FeatureSection = () => {
    return (
        <div
            style={{
                backgroundColor: '#EEF4F5',
                paddingTop: '5rem',
                paddingBottom: '5rem',
            }}
        >
            {/* Title */}
            <Row>
                <Col span={24} align='center' style={{ paddingBottom: '3rem' }}>
                    <Title>Your mental health matters</Title>
                </Col>
            </Row>

            {/* Cards */}
            <Row>
                <Col xs={24} sm={24} lg={{ span: 6, offset: 3 }}>
                    <Card
                        hoverable
                        style={{ padding: '0.5rem', margin: '1rem' }}
                    >
                        {/* icon */}
                        <div>
                            <FieldTimeOutlined
                                style={{
                                    padding: '1rem',
                                    marginBottom: '2rem',
                                    color: '#f46f7c',
                                    fontSize: '3rem',
                                    borderRadius: '50%',
                                    background: 'rgba(244, 111, 124, 0.1)',
                                }}
                            />
                        </div>

                        {/* title */}
                        <div>
                            <Title level={3}>Timeline</Title>
                        </div>

                        {/* text */}
                        <div>
                            <Text style={{ fontSize: '1rem' }}>
                                Document everything that you through, every
                                emotion, every moment matters, learn from them,
                                boost your emotion quotient.
                            </Text>
                        </div>
                        {/* cta */}
                        <div style={{ paddingTop: '1rem' }}>
                            <Text
                                strong
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    const returnTo = window.location.origin;
                                    window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                                }}
                            >
                                Learn More <ArrowRightOutlined />
                            </Text>
                        </div>
                    </Card>
                </Col>
                <Col xs={24} sm={24} lg={6}>
                    <Card
                        hoverable
                        style={{ padding: '0.5rem', margin: '1rem' }}
                    >
                        {/* icon */}
                        <div>
                            <DeploymentUnitOutlined
                                style={{
                                    padding: '1rem',
                                    marginBottom: '2rem',
                                    color: '#f46f7c',
                                    fontSize: '3rem',
                                    borderRadius: '50%',
                                    background: 'rgba(244, 111, 124, 0.1)',
                                }}
                            />
                        </div>

                        {/* title */}
                        <div>
                            <Title level={3}>Community</Title>
                        </div>

                        {/* text */}
                        <div>
                            <Text style={{ fontSize: '1rem' }}>
                                You are not alone, connect with strangers, read
                                about them and share your stories to inspire
                                other, be the change you want to see.
                            </Text>
                        </div>
                        {/* cta */}
                        <div style={{ paddingTop: '1rem' }}>
                            <Text
                                strong
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    const returnTo = window.location.origin;
                                    window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                                }}
                            >
                                Learn More <ArrowRightOutlined />
                            </Text>
                        </div>
                    </Card>
                </Col>
                <Col xs={24} sm={24} lg={6}>
                    <Card
                        hoverable
                        style={{ padding: '0.5rem', margin: '1rem' }}
                    >
                        {/* icon */}
                        <div>
                            <UserSwitchOutlined
                                style={{
                                    padding: '1rem',
                                    marginBottom: '2rem',
                                    color: '#f46f7c',
                                    fontSize: '3rem',
                                    borderRadius: '50%',
                                    background: 'rgba(244, 111, 124, 0.1)',
                                }}
                            />
                        </div>

                        {/* title */}
                        <div>
                            <Title level={3}>Personal</Title>
                        </div>

                        {/* text */}
                        <div>
                            <Text style={{ fontSize: '1rem' }}>
                                Control who can see what you post. You are the
                                owner and distributor of your content, share and
                                learn from people you care and look upto.
                            </Text>
                        </div>

                        {/* cta */}
                        <div style={{ paddingTop: '1rem' }}>
                            <Text
                                strong
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    const returnTo = window.location.origin;
                                    window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                                }}
                            >
                                Learn More <ArrowRightOutlined />
                            </Text>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default FeatureSection;
